module.exports = __webpack_public_path__ + "img/doc_drawer.2e27e3f2.gif";